import React from 'react'
import appApi from '../../classes/appApi'
import generateContextProvider from '../../shared/hooks/GenerateContextProvider'
import { useBaseConfigContext } from './AppBaseConfig'
import { useTenantlessDeploymentContext } from './AppTenantlessDeploymentProvider'

/** Tenantless API: environment/instance only; use under `AppTenantlessDeploymentProvider`. */
const AppTenantlessApiWrapper = (props: {
    provider: React.FC<{ value: appApi; children: React.ReactNode }>
    children: React.ReactNode
}) => {
    const ApiProvider = props.provider

    const config = useBaseConfigContext()
    const { environment, instance } = useTenantlessDeploymentContext()

    const api = new appApi({
        config: config.api,
        environment: environment,
        instance: instance,
    })

    return <ApiProvider value={api}>{props.children}</ApiProvider>
}

const {
    ContextProvider: AppTenantlessApiProvider,
    useContext: useTenantlessApiContext,
    useContextOptional: useTenantlessApiContextOptional,
} = generateContextProvider<appApi>(undefined, AppTenantlessApiWrapper)

export { AppTenantlessApiProvider, useTenantlessApiContext, useTenantlessApiContextOptional }
